// extracted by css-extract-rspack-plugin
export default {"cls1":"FileUpload-cls1_uZG","cls2":"FileUpload-cls2_D-a FileUpload-cls1_uZG"};